import clsx from 'clsx';

import { ButtonSkeletonProps } from '../../../components/Button/skeleton';
import ToolbarButtonSkeleton from '../../ToolbarButton/skeleton';
import { imageUploadButtonClasses } from './styles';

export interface ImageUploadButtonSkeletonProps extends ButtonSkeletonProps {
  classes?: Partial<typeof imageUploadButtonClasses>;
}

const ImageUploadButtonSkeleton = ({ className, classes, ...props }: ImageUploadButtonSkeletonProps) => {
  return (
    <ToolbarButtonSkeleton
      {...props}
      className={clsx(
        imageUploadButtonClasses.toolbarButton,
        classes?.toolbarButton,
        imageUploadButtonClasses.image,
        classes?.image
      )}
    />
  );
};

export default ImageUploadButtonSkeleton;
